import * as actions from "../actions/DbSubscriptionActions";
import { DbSubscriptionState, initialState } from "../store/DbSubscriptionState";
import buildReducer from "../utils/ReducerBuilder";

export const DbSubscriptionReducer = buildReducer<DbSubscriptionState>(initialState)
    .handle(actions.toggleInitialized, (state, action) => {
        return {
            ...state,
            initialized: action.payload || false,
        };
    })
    .handle(actions.websocketConnected, (state, action) => {
        return {
            ...state,
            websocket: action.payload,
        };
    })
    .handle(actions.websocketDisconnected, (state, action) => {
        return {
            ...state,
            websocket: undefined,
        };
    })
    .done();



// WEBPACK FOOTER //
// ./src/reducers/DbSubscriptionReducer.ts